/**
 * Helpers for sounds
 */

import { Howl } from 'howler'

var Sounds = function(elOn, elOff) {

  var VOLUME_DEFAULT = 0.7;
  var FADE_DURATION = 700;

  var sndRide, sndWait, sndOnePoints, sndThreePoints, sndLevelUp;

  var bSoundIsActive = false;
  var bDeactivateSounds = window.DEBUG_FORCE_SOUND_OFF;

  function init() {
    bSoundIsActive = true;

    sndOnePoints = new Howl({
      src: 'sounds/1points.mp3'
    })
    sndThreePoints = new Howl({
      src: 'sounds/3points.mp3'
    })
    sndLevelUp = new Howl({
      src: 'sounds/levelup.mp3'
    })
    sndWait = new Howl({
      src: 'sounds/water_wait.mp3',
      loop: true
    })
    sndRide = new Howl({
      src: 'sounds/water_ride.mp3',
      loop: true
    })
    // sndOnePoints.play();
    // sndThreePoints.play();
    // sndRide.play();
    bSoundIsActive = true
  }

  function switchSound() {
    bSoundIsActive = !bSoundIsActive
    if(bSoundIsActive && !bDeactivateSounds) {
      // sndOnePoints.volume(VOLUME_DEFAULT);
      // sndThreePoints.volume(VOLUME_DEFAULT);
      sndRide.fade(0, VOLUME_DEFAULT, FADE_DURATION);
      sndWait.fade(0, VOLUME_DEFAULT, FADE_DURATION);
    } else {
      // sndOnePoints.volume(0);
      // sndThreePoints.volume(0);
      sndRide.fade(VOLUME_DEFAULT, 0, FADE_DURATION);
      sndWait.fade(VOLUME_DEFAULT, 0, FADE_DURATION);
    }
  }

  function playOnePoints() {
    if (bSoundIsActive && !bDeactivateSounds)
      sndOnePoints.play();
  }

  function playThreePoints() {
    if (bSoundIsActive && !bDeactivateSounds)
      sndThreePoints.play();
  }

  function playLevelUp() {
    if (bSoundIsActive && !bDeactivateSounds)
      sndLevelUp.play();
  }

  function playRide() {
    // console.log(`🎵 playRide`);
    if (!bDeactivateSounds) {
      sndWait.stop();
      sndRide.play();
    }
  }

  function playWait() {
    // console.log(`🎵 playWait`);
    if (!bDeactivateSounds) {
      sndRide.stop();
      sndWait.play();
    }
  }

  function stopAll() {
    sndRide.stop();
    sndWait.stop();
  }

  function getSoundIsActive() {
    return bSoundIsActive
  }

	return {
    init,
    switchSound,
    playOnePoints,
    playThreePoints,
    playLevelUp,
    playRide,
    playWait,
    stopAll,
    getSoundIsActive
	}
};

export { Sounds as default };
